<template>
  <b-container>
    <h1>Education Type</h1>

    <b-alert variant="danger" :show="error != ''">{{ error }}</b-alert>

    <b-row>
      <b-col md="6">
        <b-button variant="primary" to="/educationtype/add">Add</b-button>
        
        <b-table-lite class="mt-2" :fields="fields" :items="educationTypes">
          <template v-slot:cell(expires)="data">
            {{ data.item.expiresIn > 0 ? `${data.item.expiresIn} ${getUnit(data.item.expiryUnit)}` : '' }} 
          </template>
          <template v-slot:cell(actions)="data">
            <div class="float-right">
            <b-button size="sm" variant="outline-secondary" class="mr-2" :to="`/educationtype/${data.item.id}`"><b-icon-card-text></b-icon-card-text></b-button>
            <b-button size="sm" variant="outline-secondary" @click="showDeleteDlg(data.item)"><b-icon-trash></b-icon-trash></b-button>
            </div>
          </template>
        </b-table-lite>
      </b-col>
    </b-row>

    <b-modal 
      title="Confirm Delete" 
      v-model="deleteDialog"
      ok-variant="danger"
      ok-title="Delete"
      cancel-variant="outline-secondary"
      @ok="deleteEducationType"
    >
      <p>Delete {{ deleteItem.name }}?</p>
    </b-modal>
  </b-container>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      fields: ['name', { key: 'expires', label: 'Expires In' }, { key: 'actions', label: '' }],
      educationTypes: [],
      deleteDialog: false,
      deleteItem: {},
      error: ''
    }
  },
  methods: {
    getUnit(id) {
      switch (id) {
        case 0: return 'Days';
        case 1: return 'Months';
        case 2: return 'Years';
        default: return '';
      }
    },
    showDeleteDlg(item) {
      this.error = '';
      this.deleteItem = item;
      this.deleteDialog = true;
    },
    deleteEducationType() {
      axios.delete(`/api/educationtypes/${this.deleteItem.id}`)
      .then(() => {
        const index = this.educationTypes.indexOf(this.deleteItem);

        if (index > -1) {
          this.educationTypes.splice(index, 1);
        }
      })
      .catch(() => {
        this.error = 'Failed to delete education type.'
      })
    }
  },
  created() {
    axios.get('/api/educationtypes')
      .then( response => {
        this.educationTypes = response.data
      }).catch(error => {
        console.log(error);
    });
  }
}
</script>